// extracted by mini-css-extract-plugin
export default {"inputWrapper":"inputWrapper---Pvuaa","textAreaLabel":"textAreaLabel---mNdAO"};